export const Types = {
  GET: 'campaigns/GET',
  SET: 'campaigns/SET',
};

const INITIAL_STATE = {
  id: null,
  name: null,
  cost: null,
  display_cost: null,
  loading: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case Types.GET:
      return { ...state, loading: true };
    case Types.SET:
      return {
        ...state,
        ...action.payload,
        loading: false,
      };
    default:
      return state;
  }
};

export const Creators = {
  getCurrentCampaign: id => ({ type: Types.GET, payload: { id } }),
  setCampaign: payload => ({
    type: Types.SET,
    payload,
  }),
};



// WEBPACK FOOTER //
// ./src/store/ducks/campaigns.js